/* Emblem Box builder: size, rose colour and box colour on the real Shopify variants. */
(function () {
  'use strict';
  var COLOURS = { red: '#A8132C', 'ravishing red': '#A8132C', pink: '#E98FA8', 'candy pink': '#F2A7C3', 'hot pink': '#E0457B', peach: '#F4BCA4', coral: '#F08A76', white: '#fff', black: '#161314',
    blue: '#9DB8D9', green: '#A9BFA0', lilac: '#C9B6DD', orange: '#E8955A', 'burnt orange': '#B85C2C', brown: '#7A5A45', grey: '#A7A3A0', sage: '#B7C4A8' };
  function swatch(v) {
    var k = String(v).toLowerCase().replace(/\s*roses?$/, '').trim();
    if (k === 'speckled') return '<i class="sw-speck"></i>';
    return COLOURS[k] ? '<i style="background:' + COLOURS[k] + '"></i>' : '';
  }
  function setup(sec) {
    if (!sec || sec._e) return; var B = window.BBC; if (!B) return;
    var dataEl = sec.querySelector('[data-emblem-data]'); if (!dataEl) return; sec._e = 1;
    var E; try { E = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var sizes = sec.querySelector('[data-sizes]'), optsEl = sec.querySelector('[data-opts]'), priceEl = sec.querySelector('[data-price]'), go = sec.querySelector('[data-go]');
    var label = go.textContent;
    var thumb = sec.querySelector('[data-thumb]'), sumName = sec.querySelector('[data-sum-name]'), sumOpts = sec.querySelector('[data-sum-opts]');
    // review card wording: "Pink roses, black box" / "12 roses, white box"
    function nice(n, v) { v = String(v).toLowerCase(); if (/box/i.test(n)) return v + ' box'; if (/rose|colou?r/i.test(n) && !/rose/.test(v)) return v + ' roses'; return v; }
    var on = sizes.querySelector('[aria-checked="true"]') || sizes.querySelector('[role="radio"]');
    var st = { i: on ? +on.getAttribute('data-i') : 0, sel: {} };
    function prod() { return E[st.i]; }
    function match(p, want) { return p.variants.filter(function (v) { return p.options.every(function (n, k) { return want[n] == null || v.o[k] === want[n]; }); }); }
    function current() { var p = prod(); if (!p) return null; var full = {}; p.options.forEach(function (n) { full[n] = st.sel[n]; }); return match(p, full)[0] || null; }
    // what a photo shows, read from its description: { 'Box Colour': 'White', 'Rose Colors': 'Red' } (longest matching value wins)
    function shows(im, p) {
      var alt = im ? String(im.alt || '').toLowerCase() : '', out = {}; if (!alt) return out;
      p.options.forEach(function (n, k) { var best = '';
        p.variants.forEach(function (v) { var val = String(v.o[k]), re = new RegExp('(^|[^a-z0-9])' + val.toLowerCase().replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '([^a-z0-9]|$)');
          if (val.length > best.length && re.test(alt)) best = val; });
        if (best) out[n] = best; });
      return out;
    }
    function isCol(n) { return /box|rose|colou?r/i.test(n); }
    // until the customer picks a colour, each size starts on the roses and box named in its (first) photo description
    function fromPhoto(p) {
      var s = shows(sec.querySelector('.sig-img[data-i="' + st.i + '"]'), p);
      Object.keys(s).forEach(function (n) { st.sel[n] = s[n]; });
    }
    // the size's photos: the big photo is the closest match (box colour counts most), the small photo in the
    // review card only shows when a photo shows exactly the box and roses picked, otherwise it is hidden
    function pickPhoto(p) {
      var best = null, bs = -1, exact = null;
      Array.prototype.forEach.call(sec.querySelectorAll('.sig-img[data-i="' + st.i + '"]'), function (im) {
        var s = shows(im, p), sc = 0, all = true;
        p.options.forEach(function (n) { if (!isCol(n)) return; if (s[n] != null && s[n] === st.sel[n]) sc += /box/i.test(n) ? 2 : 1; else all = false; });
        if (all && !exact) exact = im;
        if (sc > bs) { bs = sc; best = im; }
      });
      return { big: exact || best, exact: exact };
    }
    function normalise() {
      var p = prod(); if (!p) return;
      if (!st.touched) fromPhoto(p);
      p.options.forEach(function (n, k) {
        var vals = p.variants.map(function (v) { return v.o[k]; });
        if (vals.indexOf(st.sel[n]) < 0) { var a = p.variants.filter(function (v) { return v.a; })[0] || p.variants[0]; st.sel[n] = a.o[k]; }
      });
      if (!(current() || {}).a) { var keep = {}; Object.keys(st.sel).forEach(function (n) { keep[n] = st.sel[n]; });
        var alt = p.variants.filter(function (v) { return v.a; })[0]; if (alt) p.options.forEach(function (n, k) { st.sel[n] = alt.o[k]; }); }
    }
    function paint() {
      var p = prod(); if (!p) return;
      var ph = pickPhoto(p);
      Array.prototype.forEach.call(sec.querySelectorAll('.sig-img'), function (im) { im.classList.toggle('on', im === ph.big); });
      var html = '';
      // roses first, box last, as in the concept
      var order = p.options.map(function (n, k) { return { n: n, k: k, w: /box/i.test(n) ? 2 : /rose|colou?r/i.test(n) ? 0 : 1 }; }).sort(function (a, b) { return a.w - b.w || a.k - b.k; });
      order.forEach(function (it) { var n = it.n, k = it.k;
        if (n === 'Title') return;
        var vals = []; p.variants.forEach(function (v) { if (vals.indexOf(v.o[k]) < 0) vals.push(v.o[k]); });
        var isSw = /box|rose|colou?r/i.test(n);
        html += '<fieldset class="opt-group"><legend>' + B.esc(n.replace(/colors?/i, 'colour')) + ' <span class="val">' + B.esc(st.sel[n]) + '</span></legend>' +
          '<div class="' + (isSw ? 'swatches' : 'opts opts-3') + '" role="radiogroup" aria-label="' + B.esc(n) + '" data-n="' + B.esc(n) + '">';
        vals.forEach(function (val) {
          var want = {}; Object.keys(st.sel).forEach(function (x) { want[x] = st.sel[x]; }); want[n] = val;
          var m = match(p, want)[0], out = !m || !m.a, chk = st.sel[n] === val;
          if (isSw) html += '<button type="button" class="sw' + (out ? ' is-out' : '') + '" role="radio" aria-checked="' + chk + '" data-v="' + B.esc(val) + '">' + swatch(val) + B.esc(val) + '</button>';
          else html += '<button type="button" class="sw" role="radio" aria-checked="' + chk + '" data-v="' + B.esc(val) + '" style="border-radius:0;justify-content:center">' + B.esc(val) + (m ? ' <small style="color:var(--muted)">' + (out ? 'Sold out' : B.money(m.p)) + '</small>' : '') + '</button>';
        });
        html += '</div></fieldset>';
      });
      optsEl.innerHTML = html; B.roving(optsEl);
      var sb = sizes.querySelector('[data-i="' + st.i + '"] b');
      if (thumb) { var t = ph.exact && (ph.exact.currentSrc || ph.exact.getAttribute('data-t')); thumb.hidden = !t; thumb.style.display = t ? '' : 'none'; if (t && thumb.getAttribute('src') !== t) thumb.src = t; }
      if (sumName && sb) sumName.textContent = sb.textContent;
      if (sumOpts) { var txt = order.filter(function (it) { return it.n !== 'Title'; }).map(function (it) { return nice(it.n, st.sel[it.n]); }).join(', ');
        sumOpts.textContent = txt ? txt.charAt(0).toUpperCase() + txt.slice(1) : ''; }
      var v = current();
      priceEl.textContent = v ? B.money(v.p) : '';
      go.href = p.url + (v ? '?variant=' + v.id : '');
      if (v && v.a) { go.textContent = label; go.removeAttribute('aria-disabled'); }
      else { go.textContent = 'Sold out'; go.setAttribute('aria-disabled', 'true'); }
    }
    sizes.addEventListener('click', function (e) { var b = e.target.closest('[role="radio"]'); if (!b) return; B.radio(sizes, b); st.i = +b.getAttribute('data-i'); normalise(); paint(); });
    optsEl.addEventListener('click', function (e) {
      var b = e.target.closest('[role="radio"]'); if (!b) return; var g = b.closest('[data-n]');
      st.touched = 1; st.sel[g.getAttribute('data-n')] = b.getAttribute('data-v');
      var p = prod(), v = current();
      if (!v || !v.a) { // keep the tapped value, move the others to an available combination
        var n = g.getAttribute('data-n'), k = p.options.indexOf(n);
        var alt = p.variants.filter(function (x) { return x.o[k] === st.sel[n] && x.a; })[0];
        if (alt) p.options.forEach(function (nn, kk) { st.sel[nn] = alt.o[kk]; });
      }
      paint();
      var f = optsEl.querySelector('[data-n="' + g.getAttribute('data-n') + '"] [aria-checked="true"]'); if (f) f.focus({ preventScroll: true });
    });
    go.addEventListener('click', function (e) { if (go.getAttribute('aria-disabled') === 'true') e.preventDefault(); });
    normalise(); paint();
  }
  function all() { Array.prototype.forEach.call(document.querySelectorAll('[data-emblem]'), setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
